<template>
    <form class="mb-4">
        <div class="row">
            <div class="col-12 col-md-6">
                <label>{{$t('First name')}}</label>
                <b-form-input v-model="user.firstName" type="text" :placeholder="$t('Ex.:John')"></b-form-input>
            </div>
            <div class="col-12 col-md-6">
                <!-- Last name -->
                <div class="form-group">
                    <label>{{$t('Last name')}}</label>
                    <b-form-input v-model="user.lastName" type="text" :placeholder="$t('Ex.:Doe')"></b-form-input>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <!-- Email address -->
                <div class="form-group">
                    <label class="mb-1">Email</label>

                    <!-- <small class="form-text text-muted">This contact will be shown to others publicly.</small> -->

                    <b-form-input :value="user.email" :disabled="true" type="email" placeholder="Enter your name"></b-form-input>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label class="mb-1">{{$t('Birthdate')}}</label>
                    <!-- <small class="form-text text-muted">Only for birthday gifts.</small> -->
                    <date-input v-model="user.birthDate"></date-input>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label>{{$t('Primary phone')}}</label>
                    <vue-tel-input class="form-control"
                                   v-model="user.primaryPhone"
                                   :preferredCountries="['UZ', 'KZ', 'RU']"
                                   placeholder="">
                    </vue-tel-input>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group">
                    <label>{{$t('Secondary phone')}}</label>
                    <vue-tel-input class="form-control"
                                   v-model="user.secondaryPhone"
                                   :preferredCountries="['UZ', 'KZ', 'RU']"
                                   placeholder="">
                    </vue-tel-input>
                </div>
            </div>
        </div>
        <!-- / .row -->
        <!-- Divider -->
        <hr class="mt-4 mb-5" />

        <div class="row">
            <div class="col-12 col-md-6" v-if="1>2">
                <!-- Public profile -->
                <div class="form-group">
                    <!-- Label -->
                    <label class="mb-1">Public profile</label>

                    <!-- Form text -->
                    <small
                        class="form-text text-muted"
                    >Making your profile public means that anyone on the Dashkit network will be able to find you.</small>

                    <div class="row">
                        <div class="col-auto">
                            <!-- Switch -->
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    v-model="user.public"
                                    class="custom-control-input"
                                    id="switchOne"
                                />
                                <label class="custom-control-label" for="switchOne"></label>
                            </div>
                        </div>
                        <div class="col ml-n2">
                            <small class="text-muted" v-if="!user.public">You're currently invisible</small>
                        </div>
                    </div>
                    <!-- / .row -->
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="row">
                    <div class="col-auto" v-if="user.avatar">
                        <avatar :src="user.avatar.preview" size="avatar-xxl" type="rounded"></avatar>
                    </div>
                    <div class="col">
                        <button
                            class="btn btn-white"
                            type="button"
                            @click="openModal({id:'mediaModal', multiple:true})"
                        >
                            <span class="fe fe-image"></span>
                            {{$t('Set photo')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <button-loading
            class="btn mt-2 btn-primary"
            type="button"
            :loading="loading"
            @click="updateProfile()"
        >{{$t('Save')}}</button-loading>
        <media-modal id="mediaModal" category="profile" :action="useImage"></media-modal>
    </form>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'
import { VueTelInput } from 'vue-tel-input'

import DateInput from '@/components/DateInput.vue';
import MediaModal from '@/components/MediaModal.vue';
import ButtonLoading from '@/components/ButtonLoading'
import Avatar from '@/components/Avatar.vue';

export default {
    mixins: [modalMixins],
    components: {
        Avatar,
        DateInput,
        MediaModal,
        VueTelInput,
        ButtonLoading,
    },

    data() {
        return {
            loading: false,
            model: {}
        }
    },
    computed: {
        ...mapState('auth', [
            'user'
        ]),

        'user.birthDate': {
            get: () => {
                return this.birthDate;
            },
            set: (newValue) => {
                // this.birthDate = '2014-09-12';
            }
        }
    },
    created() {


        /* There is no need to get current user, it's already fetched in header and stored in vuex store */
        // this.getUser(this.user._id);
        // if (!this.user.avatar_id) this.user.avatar_id = null;
    },

    methods: {
        ...mapActions('profile', {
            updateUser: 'patch'
        }),
        useImage(image) {
            this.user.avatar_id = image._id;
            this.user.avatar = image;
            // this.updateUser([this.user._id, this.user, {}]);

        },
        updateProfile() {
            this.loading = true;
            this.updateUser(['me', this.user, {}]).then(result => {
                this.loading = false;
                this.$toasted.global.success({
                    message: this.$t('Profile has been updated')
                });
            }).catch(error => {
                this.loading = false;
                this.$toasted.global.error({
                    message: `Error while updating profile. ${error.message}`
                });
            });

        }
    },
}
</script>
